import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DxCoreUtils} from "../../dx-core/utiles/dx-core-utils";
import {DxDateTime} from "../../dx-core/utiles/dx-core-datetime-utils";
import {BdpkSchedulePeriodTypes} from "./bdpk-schedule-period.enum";
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";

@jsonObject
export class BdpkSchedule extends DxGridRow {

  /** Идентификатор расписания **/
  @jsonMember({name: 'id', constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  fakeId = DxCoreUtils.randomHexaDecimal();

  get id(): any {
    return this._id ? this._id : this.fakeId;
  }

  set id(value: any) {
    this._id = value;
  }

  /** Название расписания **/
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  name: string;

  /** Идентификатор объекта аналитической задачи **/
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  objectId: number;

  /** Название объекта **/
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  objectName: string;

  /** Периодичность запуска **/
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  periodId: number = 1;

  /** Идентификатор пользователя, изменившего расписание **/
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  createUserId: number;

  /** Дата изменения расписания (tinestamp) **/
  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: false })
  createDate: Date;

  /** Идентификатор пользователя, изменившего расписание **/
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  changeUserId: number;

  /** Дата изменения расписания (tinestamp) **/
  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: false })
  changeDate: Date;

  /** Дата последнего запуска расписания (tinestamp) **/
  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: false })
  lastLaunchFactDateTime: Date;

  /** Порядок **/
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  ord: number;

  /** Дата запуска YYYY-MM-DD **/
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  runDate: string = DxDateTime.dateTimeToStr(new Date(), 'YYYY-MM-DD');

  /** Время запуска HH:mm **/
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  runTime: string = '12:00';

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  cron: string;

  /** Дата запуска **/
  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: false })
  nextRun: Date;

  /** День месяца **/
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  monthDay: number = 1;

  /** День недели **/
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  weekDayId: number = 1;

  /** Параметры запуска **/
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  scheduleParams: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  humanReadableInterval: string;

  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false })
  isPaused: boolean;

  @jsonArrayMember(Number, {emitDefaultValue: false, preserveNull: false, isRequired: false})
  objectPrivileges: number[] = [];

  /**
   *  нужно для удобства редактирования. Не сериализуется
   */
   fg: FormGroup;


   get repeating(): string {
     return BdpkSchedulePeriodTypes.get(this.periodId).name;
   }

   getRowId(): any {
     return this.id;
   }
}
